import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimatePricingMode } from '../../../models/enum';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { SolEstimateTableLaborCostRowComponent } from "../sol-estimate-table-labor-cost-row/sol-estimate-table-labor-cost-row.component";
import { SolEstimateTableLaborCosts } from '../../../models/sol-estimate-table/SolEstimateTableLaborCosts';
import { SolEstimateTableRowBase } from '../../../models/sol-estimate-table/SolEstimateTableRowBase';
import { MultilingualCurrencyPipe } from "../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe";
import { DecimalPrecisionPipe } from "../../../pipes/decimal-precision-pipe/decimal-precision.pipe";

@Component({
  selector: 'app-sol-estimate-table-labor-costs',
  imports: [
    MatIconModule,
    MatButtonModule,
    CommonModule,
    TranslatePipe,
    MatFormFieldModule,
    SolEstimateTableLaborCostRowComponent,
    ReactiveFormsModule,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
],
  templateUrl: './sol-estimate-table-labor-costs.component.html',
  styleUrl: './sol-estimate-table-labor-costs.component.scss'
})
export class SolEstimateTableLaborCostsComponent implements OnInit {

  isLaborCostsExpanded: boolean = false;

  @Input() laborCostsFormGroup!: FormGroup<SolEstimateTableLaborCosts>;
  @Input() sellAsPricingMode: SolEstimatePricingMode = SolEstimatePricingMode.Line_Item;
  @Input() isMarkUpSelected: boolean = false;
  solEstimatePricingMode = SolEstimatePricingMode;

  ngOnInit(): void {
    if(!this.laborCostsFormGroup){
      return;
    }
  }

  getLaborCostRowForm(rowName: string): FormGroup<SolEstimateTableRowBase> | null {
    return this.laborCostsFormGroup?.controls[rowName  as keyof SolEstimateTableLaborCosts] as FormGroup<SolEstimateTableRowBase> ?? null;
  }



}
